module.exports = __webpack_public_path__ + "img/CVC-alt.778bc01d.svg";